import { useDispatch } from "react-redux";
import { ValidOpenstackResource } from "../../../../types";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { toggleSlidingMenu } from "../../../../../actions/toggleSlidingMenu";
import { confirmbox_open } from "../../../../../components/confirmbox/reducer/actions";
import { Icon, Popup, Table } from "semantic-ui-react";
import WrapTextWithPopup from "../../../../../components/shared/WrapTextWithPopup";
import CircularButton from "../../../../../components/shared/circularbutton/CircularButton";
import SubnetQuickView from "../../../../../components/shared/quickview/extensions/SubnetQuickView";

const SubnetItem = ({ subnet }: { subnet: ValidOpenstackResource }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onModify = useCallback(() => {
    dispatch(toggleSlidingMenu("modify", "Subnet", subnet));
  }, [dispatch, subnet]);

  const onDelete = useCallback(() => {
    dispatch(
      confirmbox_open({
        entity: "subnet",
        operation: "delete",
        resources: subnet,
      }),
    );
  }, [dispatch, subnet]);

  return (
    <Table.Row>
      <Table.Cell title={subnet.name}>
        <WrapTextWithPopup data={subnet.name} trimSize={12} />
      </Table.Cell>
      <Table.Cell title={subnet.id}>
        <SubnetQuickView subnet={subnet} />
      </Table.Cell>
      <Table.Cell title={subnet.gateway_ip}>
        <WrapTextWithPopup data={subnet.gateway_ip} trimSize={12} />
      </Table.Cell>
      <Table.Cell title={subnet.cidr}>
        <WrapTextWithPopup data={subnet.cidr} trimSize={12} />
      </Table.Cell>
      <Table.Cell>
        {subnet.task_state ? (
          <Popup
            trigger={<Icon name="spinner" loading />}
            content={subnet.task_state || subnet.status}
          />
        ) : (
          <div className="flex vcenter">
            <CircularButton
              onClick={onModify}
              className={`button button--circular margin-right-half `}
              icon="edit"
              popupContent={t(`subnets.actions.modify`)}
            />
            <CircularButton
              onClick={onDelete}
              className={`button button--circular margin-right-half button--circular__danger`}
              icon="trash"
              popupContent={t(`subnets.actions.delete`)}
            />
          </div>
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default SubnetItem;
